const clientId = process.env.REACT_APP_DISCORD_CLIENT_ID;

export const DISCORD_OAUTH_REDIRECT_URL = (redirectUrl) =>
  `https://discord.com/api/oauth2/authorize?client_id=${clientId}&redirect_uri=${encodeURIComponent(
    redirectUrl
  )}&response_type=token&scope=identify`;
